import DetailsDeploymentDrawer, {
  DetailsDeploymentDrawerProps
} from './DetailsDeploymentDrawer';
import DetailsDeploymentWithServerless from './DetailsDeploymentWithServerless';
import { useDeploymentDetailsDrawerEnabled } from '../../hooks/useDeploymentDetailsDrawerEnabled';

/**
 * Picks the deployment details sidesheet: the HeroUI drawer when
 * `run_deployment_details_heroui` is on, the beehive one otherwise. Both take the same props, so
 * flipping the flag changes nothing but the rendering.
 */
export const DetailsDeploymentSwitcher = (
  props: DetailsDeploymentDrawerProps
) => {
  const { isEnabled } = useDeploymentDetailsDrawerEnabled();

  if (isEnabled) {
    return <DetailsDeploymentDrawer {...props} />;
  }

  return <DetailsDeploymentWithServerless {...props} />;
};

export default DetailsDeploymentSwitcher;
